module.exports = "/_next/static/images/coconuts_ramen-eedb957a46b94e52c1f8a4d9e4c0f891.jpg";